import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import { Typography, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import Drawer from '../../control/Drawer'
import Scrollbar from '../../control/Scrollbar'

type UnblockPopupDetailProps = {
    onClose: () => void
    isOpen: boolean
}
const UnblockPopupDetail = (props: UnblockPopupDetailProps) => {
    const { onClose, isOpen } = props
    const classes = useStyles()

    return (
        <Drawer
            hideBackdrop
            isOpen={isOpen}
            inlineStyle={{ position: 'unset' }}
            overrideClass={{ paper: classes.drawerPaper }}
        >
            <StyledContainer>
                <StyledTitle>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            left: 10,
                            top: 15,
                        }}
                        className={classes.backIcon}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <StyledTypography variant="body2">{'วิธี Unblock Pop-up บน iOS'}</StyledTypography>
                </StyledTitle>
                <StyledContent>
                    <div style={{ width: '100%', height: '100%' }}>
                        <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                            <StyledContentGuide>
                                <StyledImg
                                    src={`${process.env.REACT_APP_IMAGE_PATH}/assets/image/iOS_setting.png`}
                                />
                            </StyledContentGuide>
                        </Scrollbar>
                    </div>
                </StyledContent>
            </StyledContainer>
        </Drawer>
    )
}

export default UnblockPopupDetail

const useStyles = makeStyles((theme: Theme) => ({
    drawerPaper: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    backIcon: {
        color: `${theme.palette.text.secondary} !important`,
    },
    divButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: theme.spacing(1),
    },
    icon: {
        color: `${theme.palette.primary.dark} !important`,
        marginRight: theme.spacing(1),
    },
    divider: {
        margin: '10px 0px !important',
    },
    dividerMUX: {
        margin: '5px 0px !important',
    },
    tooltip: {
        margin: '0px !important',
    },
    button: {
        width: '150px',
        minHeight: '37px',
    },
}))

const StyledContainer = styled('div')(({ theme }) => ({
    width: '350px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}))

const StyledTitle = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 0px',
    backgroundColor: theme.palette.secondary.main,
    boxShadow: theme.palette.getContrastText('shadow-bottom'),
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
}))

const StyledContent = styled('div')(({ theme }) => ({
    display: 'flex',
    height: `calc(100% - 63px)`,
}))

const StyledContentGuide = styled('div')(({ theme }) => ({
    margin: '20px',
}))

const StyledImg = styled('img')(({ theme }) => ({
    width: '100%',
}))
